"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.confirmed.title': 'Payment Successful!',
    'payment.confirmed.message': 'Thank you for your payment. Your transaction has been completed successfully.',
    'payment.confirmed.details': 'Payment Details',
    'payment.confirmed.date': 'Payment Date',
    'payment.confirmed.paymentIntent': 'Payment Intent ID',
    'payment.confirmed.fetchError': 'Unable to fetch payment details',
    'payment.confirmed.unknownProvider': 'Unknown Provider',
    'payment.confirmed.accountUpgraded': 'Account Upgraded Successfully',
    'payment.confirmed.accountUpgradedMessage': 'Your account has been upgraded and new features are now available.',
    'payment.confirmed.nextSteps': 'What\'s Next?',
    'payment.confirmed.nextStepsMessage': 'You can now start using your upgraded features. Explore AI chat, create avatars, and manage your knowledge base.',
    'payment.confirmed.startChatting': 'Start Chatting',
    'payment.confirmed.viewAccount': 'View Account',
    'payment.confirmed.backHome': 'Back to Home',
    'payment.confirmed.receiptInfo': 'A receipt has been sent to your email address. You can also download it from your account settings.',
};
